import { render, staticRenderFns } from "./FeeTable.vue?vue&type=template&id=70c77767&scoped=true"
import script from "./FeeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FeeTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FeeTable.vue?vue&type=style&index=0&id=70c77767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c77767",
  null
  
)

export default component.exports